
import classes from './AveragingScore.module.css'
import AveragingScoreChart from "./AveragingScoreChart"
import { useSelector } from 'react-redux';

const AveragingScore = ({ avergeScore, avergeClass, prvScoreAverage, titleText }) => {


    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.AveregeScoreChart}>
            <div className={classes.AveregeScoreTitle}>
                <div className={classes.ScoreIcon}></div>
                <div >{titleText ? titleText : texts.averagingScore}</div>
            </div>
            <AveragingScoreChart progress={avergeScore ? avergeScore - prvScoreAverage : 0} avergeScore={avergeScore ? avergeScore : 0} avergeClass={avergeClass}></AveragingScoreChart>
        </div>
    )
}
export default AveragingScore